import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  styled,
  Typography,
} from "@mui/material";
import { SubProperty } from "../../../types";
import PropertyInfo from "..";
import { ChevronDown } from "lucide-react";
import TrackContainer from "./track-container";

const CustomAccordion = styled(Accordion)(({ theme }) => ({
  "&:first-of-type": {
    borderTopLeftRadius: theme.nawy.radius.xl,
    borderTopRightRadius: theme.nawy.radius.xl,
  },
  "&:last-of-type": {
    borderBottomLeftRadius: theme.nawy.radius.xl,
    borderBottomRightRadius: theme.nawy.radius.xl,
  },
}));

export default function SubPropertyCollapsibleCard({
  property,
}: {
  property: SubProperty;
}) {
  return (
    <Box>
      <CustomAccordion
        sx={(theme) => ({
          backgroundColor: theme.nawy.colors.semantic.layer.primary,
          boxShadow: "none",
        })}
      >
        <AccordionSummary expandIcon={<ChevronDown />}>
          <Box
            sx={(theme) => ({
              display: "flex",
              flexDirection: "column",
              gap: theme.nawy.spacing.xs,
            })}
          >
            <Box
              sx={(theme) => ({
                display: "flex",
                alignItems: "start",

                gap: theme.nawy.spacing.md,
              })}
            >
              <Typography
                sx={(theme) => ({
                  ...theme.nawy.typography.english.variants.body.lg.semibold,
                })}
              >
                {property.propertyType?.name} • {property.unitId}
              </Typography>
            </Box>
            <Typography
              sx={(theme) => ({
                ...theme.nawy.typography.english.variants.body.sm.regular,
                color: theme.nawy.colors.semantic.text.secondary,
              })}
            >
              {property.description || "No description available."}
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            gap: theme.nawy.spacing.md,
          })}
        >
          <PropertyInfo property={property} />
          {property.propertyTrack?.length > 0 && (
            <Box
              sx={(theme) => ({
                display: "flex",
                flexDirection: "column",
                gap: theme.nawy.spacing.sm,
              })}
            >
              <Box
                sx={(theme) => ({
                  display: "flex",
                  gap: theme.nawy.spacing.xxs,
                })}
              >
                <Typography
                  sx={(theme) =>
                    theme.nawy.typography.english.variants.body.xs.semibold
                  }
                >
                  Tracks
                </Typography>
                <Typography
                  sx={(theme) =>
                    theme.nawy.typography.english.variants.body.xs.regular
                  }
                >
                  ({property.propertyTrack?.length ?? 0})
                </Typography>
              </Box>
              <Box
                sx={(theme) => ({
                  display: "flex",
                  alignItems: "center",
                  gap: theme.nawy.spacing.md,
                })}
              >
                {property.propertyTrack.map((track) => (
                  <TrackContainer track={track} />
                ))}
              </Box>
            </Box>
          )}
        </AccordionDetails>
      </CustomAccordion>
    </Box>
  );
}
